export default __webpack_public_path__ + "static/media/grab.542beaae.png";